<template>
  <div
    :class="['zg-form-error', {
      'zg-form-error--visible': visible,
      [`zg-form-error--type-${type}`]: type
    }]"
  >
    <zg-messaging-inline-text
      :type="type"
      background="none"
      padding="xsmall"
    >
      <slot />
    </zg-messaging-inline-text>
  </div>
</template>

<script>
  import ZgMessagingInlineText from '../ZgMessagingInlineText/ZgMessagingInlineText.vue'

  export default {
    name: 'ZgFormError',
    components: {
      ZgMessagingInlineText
    },
    props: {
      visible: {
        type: Boolean,
        required: false,
        default: false
      },
      type: {
        type: String,
        required: false,
        default: 'error',
        validator: (value) => [
          'error',
          'warning'
        ].includes(value)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-form-error {
    max-height: 0;
    max-width: 100%;
    width: 100%;
    opacity: 0;
    transition: all 0.4s ease-in-out;
    overflow: hidden;

    ::v-deep .zg-messaging-inline-text {
      @include type-body-s;

      grid-gap: rem(6px);
      color: color(gray-500);
      padding-left: 0;
      padding-right: 0;
      margin: 0;
      width: 100%;

      svg {
        width: rhythm(2);
        height: rhythm(2);
        margin-top: rem(3px);
      }
    }
  }

  // ? ----------------------------------------------------------------------
  // modifiers
  // ? ----------------------------------------------------------------------

  .zg-form-error--visible {
    max-height: rem(200px);
    opacity: 1;
  }

  // ? ----------------------------------------------------------------------
  // types
  // ? ----------------------------------------------------------------------

  .zg-form-error--type-error {
    ::v-deep .zg-messaging-inline-text {
      svg {
        fill: color(error-500);
      }
    }
  }

  .zg-form-error--type-warning {
    ::v-deep .zg-messaging-inline-text {
      svg {
        fill: color(warning-500);
      }
    }
  }
</style>
